module.exports = __webpack_public_path__ + "icon_arrow.svg?930b008e8809849e756dbcd61fc1eb6d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_arrow.svg
// module id = 146
// module chunks = 0